import React from "react";
import { observer, inject } from "mobx-react";

import ProviderLogo from "ComponentsUI/Tariffication/components/ProviderLogo";
import Price from "ComponentsUI/Tariffication/components/Price";
import DodyList from "ComponentsUI/Tariffication/components/DodyList";
import Measurements from "ComponentsUI/Tariffication/components/Measurements";
import PlanAHeader from "ComponentsUI/Tariffication/components/PlanAHeader";
import MobileData from "ComponentsUI/Tariffication/components/MobileData";
import TariffButton from "ComponentsUI/Tariffication/components/Button";
import TV from "ComponentsUI/Tariffication/components/TV";
import PlanALayout from "ComponentsUI/Tariffication/layouts/PlanALayout";
import PriceWithChangeLayout from "ComponentsUI/Tariffication/layouts/PriceWithChangeLayout";
import PriceWithAvansLayout from "ComponentsUI/Tariffication/layouts/PriceWithAvansLayout";
import ButtonsLayout from "ComponentsUI/Tariffication/layouts/ButtonsLayout";

import { AddDoc, AddedDoc } from "ComponentsUI/Icons";
import { Link } from "react-router-dom";
import throttle from "lodash/throttle";
import { sendMetriks } from "Services/sendMetriks";
import Metrika from "Services/Metrika";
import { generateUrl } from "Services/withDefaultParams";

var Routes = require("Configs/routes");

import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import NoIndex from "ComponentsUI/NoIndex";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { EVENT_ACTION_CLICK_EXPAND_DODYS } from "Constants/metriks/GoogleActions";
import { ModalLayout } from "ComponentsUI/Modallayout";
import { TARIFF_BY_ID } from "Services/queries";

@inject("ApplicationModel")
@observer
export default class PlanAContainer extends React.Component {
	constructor(props) {
		super(props);
		let data = props.data;
		let text = this.props.ApplicationModel.text;
		let switcherArray = [],
			typesCounter = 0;
		if (!!data.internet) {
			typesCounter++;
			switcherArray.push({
				name: "internet",
				text: "Домашний интернет",
				active: true,
				value: data.internet.speed_in,
				measure: text.MB_PER_SECOND,
			});
		}
		if (!!data.tv && data.tv.channels) {
			let channels = data.tv.channels;
			if (data.tv.channels_hd) {
				channels += " + " + data.tv.channels_hd + "HD";
			}
			switcherArray.push({
				name: "tv",
				text: "Цифровое тв",
				active: !typesCounter,
				value: channels,
				measure: text.comparisonСhannelsNumber,
			});
			typesCounter++;
		}
		if (!!data.mobile && !!data.mobile.length) {
			let packages = data.mobile[0].packages;
			let inet = null,
				sms = null,
				minutes = null;
			packages.forEach((item) => {
				if (item.id == 5) {
					inet = item;
				}
				if (item.id == 6) {
					sms = item;
				}
				if (item.id == 7) {
					minutes = item;
				}
			});
			switcherArray.push({
				name: "mobile",
				text: "Мобильная связь",
				active: false,
				value: [
					{
						value: minutes.count,
						measure: text.MIN,
					},
					{
						value: sms.count,
						measure: text.SMS,
					},
					{
						value: inet.count,
						measure: text.GB,
					},
				],
			});
			this.mobileData = [
				{
					value: minutes.count,
					measure: text.MIN,
				},
				{
					value: sms.count,
					measure: text.SMS,
				},
				{
					value: inet.count,
					measure: text.GB,
				},
			];
		}
		this.state = {
			switcher: switcherArray.length > 1 ? switcherArray : null,
		};

		this.throttledConnPopup = throttle((data) => this.props.openConnectionRequest(data), 300);
		this.throttledOnClick = throttle((data) => this.props.onClick(data), 300);
	}

	static defaultProps = {
		data: {},
	};

	dodysExpand() {
		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_CLICK_BUTTON,
			EVENT_ACTION_CLICK_EXPAND_DODYS
		);
	}

	onReviewClick() {
		let modalModel = this.props.ApplicationModel.modalModel;
		let text = this.props.ApplicationModel.text;
		import("Containers/RatesReviews/index").then((RatesReviewsContainer) => {
			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<RatesReviewsContainer.default text={text} provider={this.props.data.provider} />
				</ModalLayout>
			);
		});
	}

	clickPhoneHandler() {
		// Metrika.getInstance().google.sendEvent(
		//     EVENT_CATEGORY_CLICK_BUTTON,
		//     EVENT_ACTION_CLICK_COMPASSION_BUTTON_FAKE
		// );
		sendMetriks("CLICK_COMPASSION_PHONE_BUTTON_FAKE");
	}

	changeTab(name) {
		let switcherArray = this.state.switcher.map((item) => {
			item.active = false;
			if (item.name == name) {
				item.active = true;
			}
			return item;
		});
		this.setState({
			switcher: switcherArray,
		});
	}

	connectHandler(e) {
		if (this.props.withPopup) {
			e.preventDefault();
			this.throttledConnPopup(this.props.data);
		}
		this.throttledOnClick(this.props.data);
	}

	closeModal() {
		let modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}

	onClickAddHandlerTv() {
		if (!!this.props.data.tv.use_text) {
			return;
		}

		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let promise1 = import("Layouts/modalLayout");
		let promise2 = import("Containers/ChannelsContainer");
		let apolloTariffQueryPromise = this.props.ApplicationModel.apolloTransportLayer.query({
			query: TARIFF_BY_ID,
			variables: {
				id: this.props.data.id,
			},
		});
		Promise.all([promise1, promise2, apolloTariffQueryPromise]).then((modules) => {
			let ModalLayout = modules[0].default;
			let ChannelsContainer = modules[1].default;
			let tariff = modules[2].data.tariffsOne;
			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<ChannelsContainer provider={tariff.provider} channels={tariff.channels} />
				</ModalLayout>
			);
		});
	}

	onClickHandler(props, tariff_id) {
		const {
			ApplicationModel: { tariffsModel },
		} = this.props;
		tariffsModel.setTariffId(tariff_id);
	}

	render() {
		let {
			showLogo,
			data,
			ApplicationModel: { text },
		} = this.props;

		let compareModel = this.props.ApplicationModel.compareTarifficationsModel;

		const inCompare = compareModel.findTariff(data);

		let orderToHomeUrl = generateUrl(Routes.OrderHome.route, {
			regionUrl: data.region.url,
		});
		orderToHomeUrl = {
			pathname: orderToHomeUrl,
		};

		let valuePrice = {
			price: data.price.license_fee,
		};
		const priceText = {
			SUBSCRIPTION_FEE_TITLE: `р/${data.price.license_fee_interval.name_short}`,
			SUBSCRIPTION_FEE_TITLE_: text.SUBSCRIPTION_FEE_TITLE_,
		};
		if (!!data.after.change && data.after.change.length) {
			let changePrice = 0;
			data.after.change.map((item) => {
				if (item.id == 4) {
					changePrice = 1;
				}
			});
			if (changePrice == 1) {
				valuePrice = {
					price: data.after.data.price.license_fee,
					sale: data.price.license_fee,
				};

				if (
					data.after.data.price.license_fee_interval &&
					data.after.data.price.license_fee_interval.name_short
				) {
					priceText.SUBSCRIPTION_FEE_TITLE_ = `р/${data.after.data.price.license_fee_interval.name_short}`;
				}
			}
		}

		let speedHeader = data.internet && (
			<Measurements
				big={true}
				value={data.internet && data.internet.speed_in}
				measure={text.MB_PER_SECOND}
			/>
		);
		let priceHeader = (
			<Measurements
				value={valuePrice.sale ? valuePrice.sale + "*" : valuePrice.price}
				measure={text.SUBSCRIPTION_FEE_TITLE}
				green={!!valuePrice.sale}
				onlyXs
			/>
		);
		let channels = null;
		if (data.tv && data.tv.channels) {
			channels = data.tv.channels;
			if (data.tv.channels_hd) {
				channels += " + " + data.tv.channels_hd + "HD";
			}
		}

		let channelsHeader = channels ? (
			<Measurements
				purple={true}
				onClickHandler={() => this.onClickAddHandlerTv()}
				value={channels}
				measure={text.comparisonСhannelsNumber}
				bold={true}
				noPointer={!!data.tv.use_text}
			/>
		) : null;

		let header = (
			<PlanAHeader
				speedORtv={speedHeader ? speedHeader : <TV text={text} />}
				price={priceHeader}
				channels={channelsHeader}
			/>
		);

		let price = <Price value={valuePrice.price} text={priceText} />;

		if (valuePrice.sale) {
			price = (
				<PriceWithChangeLayout
					text={text}
					valueBefore={valuePrice.sale}
					valueAfter={valuePrice.price}
				/>
			);
		}

		if (
			this.props.data.connection.price > 0 ||
			this.props.data.price.system_calculation_connect > 0
		) {
			let string = "";
			let connectPrice = null;
			if (this.props.data.price.system_calculation_connect == 0) {
				string = `+${text.servicesConnect} `;
				connectPrice = this.props.data.connection.price + text.servicesRub;
			}

			if (this.props.data.price.system_calculation_connect > 0) {
				string = `+${text.AVANS}`;
				connectPrice = this.props.data.price.system_calculation_connect + text.servicesRub;
			}
			price = (
				<PriceWithAvansLayout
					text={priceText}
					value={valuePrice.sale ? valuePrice.sale : valuePrice.price}
					avansText={string}
					avansValue={connectPrice}
					after={!!valuePrice.sale}
				/>
			);
		}

		let logoArray = [];
		if (data.provider) {
			logoArray.push(replaceStaticHost(data.provider.logo_2));
		}

		let buttons = this.props.withoutButtons ? null : (
			<ButtonsLayout
				connectButton={
					<TariffButton
						onClick={(e) => this.connectHandler(e)}
						datatest="providers_form_inspect_connect_tariff_button"
						wrapper={
							<Link to={orderToHomeUrl} onClick={() => this.onClickHandler(props, data.id)} />
						}
					>
						<span>{text.CONNECT}</span>
					</TariffButton>
				}
				compareButton={
					<TariffButton
						grey={inCompare}
						inCompare={inCompare}
						datatest="tariff_compare_button"
						onClick={() => compareModel.addToCompare(data)}
					>
						{inCompare && <AddedDoc grey={true} />}
						{!inCompare && <AddDoc />}
						<NoIndex>{inCompare ? text.ADDED : text.COMPARE}</NoIndex>
					</TariffButton>
				}
			/>
		);

		let switcher = null;
		let mobileInfo = null;
		if (!!this.mobileData) {
			mobileInfo = <MobileData data={this.mobileData} />;
		}

		let rating = data.provider.rating && data.provider.rating.expert.final;
		let reviewsCounter = data.provider.reviews_info.count_total;
		let dodys = !!data.dody && !!data.dody.length ? [...data.dody] : [];

		return (
			<PlanALayout
				text={text}
				switcher={switcher}
				mobileInfo={mobileInfo}
				header={header}
				price={price}
				elite={data.exclusives}
				dody={
					!!dodys.length ? (
						<DodyList onClickMoreHandler={() => this.dodysExpand()} items={dodys} limit={3} />
					) : null
				}
				logo={
					<ProviderLogo
						webpTransformer={webpTransformer}
						text={text}
						showLogo={showLogo}
						items={logoArray}
						rating={rating}
						name={this.props.data.provider.name}
						reviewsCounter={reviewsCounter}
						onReviewClick={() => this.onReviewClick()}
					/>
				}
				buttons={buttons}
				disabled={this.props.disabled}
				showLogo={showLogo}
				onClick={() => this.props.onClick(data)}
			/>
		);
	}
}
